export default __webpack_public_path__ + "static/media/Vincent_Halftone.688128ba.png";